import { spawnBurst, stepSparks, type Spark } from "./sparkModel.js";

export function glitterSpeed(prevTip: number, tipX: number, width: number): number {
  if (prevTip < 0) return 0;
  return Math.abs(tipX - prevTip) / width;
}

export function tickSparks(
  sparks: Spark[],
  dt: number,
  tipX: number,
  barY: number,
  speed: number,
  moving: boolean,
  intense: boolean,
  colors?: readonly string[],
): Spark[] {
  const born = moving ? spawnBurst(tipX, barY, speed, intense, Math.random, colors) : [];
  return stepSparks(sparks.concat(born), dt);
}
